import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {WSAttributesVersion} from "../types/WebSocketTypes"
import {attributeVersionApi} from "../api/attributeVersionApi"
import {AttributesVersionResponse, AttributesVersionsResponse} from "../models/response"

export type AttributesVersionsFilter = {
    limit: number
    offset: number
}

type InitialStateType = {
    versions: null | AttributesVersionsResponse
    version: null | AttributesVersionResponse
    filter: AttributesVersionsFilter
    ws: WSAttributesVersion | null
}

const initialState: InitialStateType = {
    versions: null,
    version: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const attributesVersionReducer = createSlice({
    name: 'attributesVersionReducer',
    initialState,
    reducers: {
        setAttributesVersions(state, {payload}) {
            state.versions = payload
        },
        setAttributesVersion(state, {payload}) {
            state.version = payload
        },
        addAttributesVersion(state, {payload}) {
            if (state.versions) {
                state.versions = {
                    total: state.versions.total += 1,
                    data: [payload, ...state.versions.data],
                }
            }
        },
        editAttributesVersion(state, {payload}: PayloadAction<AttributesVersionResponse>) {
            let index = state.versions?.data.findIndex(i => i.version === payload.version)
            if (index !== undefined && state.versions) state.versions.data[index] = payload
            if (state.version) state.version = payload
        },
        setAttributesVersionsFilter(state, {payload}) {
            state.filter = payload
        },
        setWSAttributesVersion(state, {payload}: PayloadAction<WSAttributesVersion | null>) {
            state.ws = payload
        },
    },
})

export const {setAttributesVersions, setAttributesVersion, addAttributesVersion, editAttributesVersion, setAttributesVersionsFilter, setWSAttributesVersion} = attributesVersionReducer.actions

export default attributesVersionReducer.reducer

export const getAttributesVersions = asyncCreator
('attributesVersionReducer/getAttributesVersions', attributeVersionApi.getVersions, setAttributesVersions)

export const getAttributesVersion = asyncCreator
('attributesVersionReducer/getAttributesVersion', attributeVersionApi.getVersion, setAttributesVersion)

export const createAttributesVersion = asyncCreator
('attributesVersionReducer/createAttributesVersion', attributeVersionApi.createVersion, addAttributesVersion)

export const changeAttributesVersion = asyncCreator
('attributesVersionReducer/changeAttributesVersion', attributeVersionApi.changeVersion, editAttributesVersion)
